/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import { createAPIAction } from './api';
import { createTypesMap } from './types';

export const types = createTypesMap('chplan', [
  'getChannelPlans',
  'getChannelPlan',
  'updateChannelPlan',
  'getChannelDefines',
  'getDataRates',
  'deleteChannelPlan',
]);

function getChannelPlans(args = { sort: '-ctime', limit: 100 }) {
  return createAPIAction(
    types.getChannelPlans,
    {
      endpoint: '/lora/chplans',
      query: args,
    },
  )();
}

function getChannelPlan(id) {
  return createAPIAction(
    types.getChannelPlan,
    {
      endpoint: `/lora/chplans/${id}`,
    },
  )();
}

function updateChannelPlan(id, data) {
  return createAPIAction(
    types.updateChannelPlan,
    {
      endpoint: `/lora/chplans/${id}`,
      body: data,
      method: 'PUT',
    },
  )();
}

function getChannelDefines(band) {
  return createAPIAction(
    types.getChannelDefines,
    {
      endpoint: `/lora/band/${band}/channeldefines`,
    },
  )();
}

function getDataRates(band) {
  return createAPIAction(
    types.getDataRates,
    {
      endpoint: `/lora/band/${band}/datarates`,
    },
  )();
}

function deleteChannelPlan(id) {
  return createAPIAction(
    types.deleteChannelPlan,
    {
      endpoint: `/lora/chplans/${id}`,
      method: 'DELETE',
    },
  )();
}

export default {
  getChannelPlans,
  getChannelPlan,
  updateChannelPlan,
  getChannelDefines,
  getDataRates,
  deleteChannelPlan,
};




// WEBPACK FOOTER //
// ./src/redux/actions/chplan.js